import React from 'react';
import Helmet from 'react-helmet';

import { useIntl } from 'ha/i18n';

const Organization: React.FC = () => {
  const { urlResolver } = useIntl();

  return (
    <Helmet>
      <script type="application/ld+json">
        {`{
            "@context": "http://schema.org",
            "@type": "Organization",
            "name": "HousingAnywhere.com",
            "legalName": "HousingAnywhere B.V.",
            "url": "${urlResolver.absolutizePath(`/`)}",
            "logo": "${urlResolver.getBaseUrl()}/img/logo-840x240.png",
            "foundingDate": "2009",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Blaak 555",
              "addressLocality": "Rotterdam",
              "postalCode": "3011 GB",
              "addressCountry": "NLD"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "contactType": "customer support",
              "telephone": "[+31 85 888 1399]",
              "email": "support@housinganywhere.com"
            },
            "sameAs": [
              "${urlResolver.getFacebookUrl()}",
              "${urlResolver.getTwitterUrl()}",
              "${urlResolver.getYoutubeUrl()}",
              "${urlResolver.getLinkedinUrl()}"
            ]
          }
        `}
      </script>
    </Helmet>
  );
};

export default Organization;
